module.exports = __webpack_public_path__ + "img/factoring-visual.d55fdb09.svg";